import type { SVGProps } from "react";

export const Plus = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <rect
        width="1.945"
        height="18"
        x="21"
        y="11.028"
        fill="currentColor"
        rx=".972"
        transform="rotate(90 21 11.028)"
      />
      <rect
        width="1.844"
        height="18"
        x="11.078"
        y="3"
        fill="currentColor"
        rx=".922"
      />
    </svg>
  );
};
